import React, { Component } from 'react';
import { convertDate } from '../../../utils/utils';
import { nl2br } from '../../../utils/nl2br';
import { parseUnderlines } from '../../../utils/parseUnderlines';

import ReviewAccordions from './ReviewAccordions';
import ReviewQuestionSwitch from './ReviewQuestionSwitch';
import FlagIcon from '../../icons/FlagIcon';

class ReviewQuestion extends Component {
  renderObservations = text => (
    <div className="review-detail__comments review-detail__comments--in-question">
      {nl2br(text) || 'N/A'}
    </div>
  )

  render() {
    const { question, theseAssessments, sectionTheme, colClass } = this.props;
    const firstAnswer = theseAssessments[0].answers[question.id];
    const hasNoParts = !question.parts || question.parts.length === 0;
    // Gray out the question number if there's no answer
    // (either a real part or, if there are no parts, the observations)
    const questionIsUnanswered = theseAssessments.every(assessment => (
      !assessment.answers[question.id] // answer object is blank
      || (!hasNoParts && !assessment.answers[question.id].parts) // answer parts are blank
      || (hasNoParts && !assessment.answers[question.id].observations) // question has no parts and answer has no observations
    ));
    const accordionAnswers = theseAssessments.map(assessment => assessment.answers[question.id]);

    return (
      <div className="review-detail__question">
        <div className="row">
          <div className="review-detail__full-width-col review-detail__question-content">
            <div className={`review-detail__question-number review-detail__question-number--${questionIsUnanswered ? 'disabled' : sectionTheme}`}>
              {question.index + 1}
            </div>
            <div className="review-detail__question-wrapper">
              <div className="review-detail__question-inner-wrapper row">
                <div className="review-detail__question-text">
                  {parseUnderlines(question.content)}
                  {theseAssessments.length === 1 && firstAnswer && firstAnswer.flagged && (
                    <FlagIcon />
                  )}
                </div>
                {question.label && (
                  <div className="review-detail__question-label">
                    {question.label}
                  </div>
                )}
                {question.subContent && (
                  <div className="review-detail__question-label">
                    {question.subContent}
                  </div>
                )}
                {(!question.parts || question.parts.length === 0) && (
                  <div className="review-detail__observations-subhead">
                    Observations and Responses
                  </div>
                )}
                {theseAssessments.map((assessment) => {
                  const answer = assessment.answers[question.id];
                  if (hasNoParts && answer) {
                    return (
                      <div className={`${colClass} review-detail__answer`} key={assessment.id}>
                        <div className="review-detail__date">
                          {convertDate(assessment.dateCompleted)}
                          {answer.flagged && (
                            <div>
                              <FlagIcon />
                            </div>
                          )}
                        </div>
                        {this.renderObservations(answer.observations)}
                      </div>
                    );
                  }
                  if (!answer || !answer.parts) {
                    return (
                      <div className={`${colClass} unanswered review-detail__answer`} key={assessment.id}>
                        <div className="review-detail__date">
                          {convertDate(assessment.dateCompleted)}
                          {answer && answer.flagged && (
                            <div>
                              <FlagIcon />
                            </div>
                          )}
                        </div>
                        <div className="review-detail__digit">
                          N/A
                        </div>
                      </div>
                    );
                  }
                  return (
                    <div className={`${colClass} review-detail__answer`} key={assessment.id}>
                      <div className="review-detail__date">
                        {convertDate(assessment.dateCompleted)}
                        {answer.flagged && (
                          <div>
                            <FlagIcon />
                          </div>
                        )}
                      </div>
                      <ReviewQuestionSwitch
                        question={question}
                        answer={answer}
                      />
                    </div>
                  );
                })}
                <ReviewAccordions
                  colClass={colClass}
                  hasNoParts={hasNoParts}
                  answers={accordionAnswers}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReviewQuestion;



// WEBPACK FOOTER //
// ./src/components/features/review/ReviewQuestion.js